// Pinia store for managing the UpdateMessageModal
// Provides a way to register the modal instance and request user input via the modal
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useUpdateMessageStore = defineStore('updateMessage', () => {
    // Holds a reference to the modal instance (set from App.vue)
    const modalRef = ref(null)

    // Called from App.vue to register the modal instance
    function register(modalInstance) {
        modalRef.value = modalInstance
    }

    // Opens the modal and returns a Promise that resolves with the user's message or null
    // action: string describing the context (e.g., 'destroy' or 'update')
    // required: whether a message is required
    // minLength: minimum length for the message
    async function request({ action, required = true, minLength = 10, record = null }) {
        if (!required) return null // If not required, skip modal
        const modal = modalRef.value
        if (!modal?.open) {
            // Modal not registered or missing open method
            console.warn('UpdateMessageModal is not registered')
            return null
        }

        // Open the modal and wait for user input
        return await modal.open({
            title: 'Begrundelse',
            action: action,
            okText: 'Ok',
            cancelText: 'Annuller',
            required: true,
            minLength,
            record: record ? record : null
        })
    }

    // Expose register and request to consumers
    return { register, request }
})
